export default [
    {
        path: 'admin/parametros/:aba?',
        name: 'admin.parametros',
        component: require('./Index').default,
        meta: { middleware: 'auth', controller: 'ConfiguracaoController' }
    },
    {
        path: 'admin/sms',
        component: require('./Sms').default,
        meta: { middleware: 'auth', controller: 'ConfiguracaoController' }
    },
];


